<template>
  <CModal
    centered
    :closeOnBackdrop="false"
    :show.sync="modalVisible"
    addContentClasses="border-0 modal-border-radius"
  >
    <div slot="header" />
    <div slot="header-wrapper" />
    <div slot="body-wrapper">
      <CContainer style="padding: 3.125rem">
        <CRow alignHorizontal="center">
          <img src="@/assets/images/admin/Caution.svg" style="width: 100px; margin-bottom:30px" />
        </CRow>
        <CRow alignHorizontal="center">
          <div class="modal-title">{{modalTitle}}</div>
        </CRow>
        <CRow alignHorizontal="center">
          <div class="modal-detail">{{modalDetails}}</div>
        </CRow>
        <CRow alignHorizontal="around">
          <div class="button button-pink" @click="setModalVisible">CANCEL</div>
          <div class="button button-green">CONFIRM</div>
        </CRow>
      </CContainer>
    </div>
    <div slot="footer" />
    <div slot="footer-wrapper" />
  </CModal>
</template>

<script>
export default {
  name: "CustomConfirmModalAlert",
  props: {
    modalVisible: Boolean,
    setModalVisible: Function,
    modalTitle: String,
    modalDetails: String
  }
};
</script>
